export default "__VITE_ASSET__Cj_5Hzab__"